module.exports = __webpack_public_path__ + "img/artwork_banner.7220958c.png";